import * as React from "react";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme } from "app/theme-context";

const MuiThemeProviderDynamic: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { cssProperties } = useTheme();
    const primaryColor = cssProperties.primaryColor || "#2C474D";
    const backgroundColor = cssProperties.backgroundColor || "#D9F5B3";
    const secondaryColor = cssProperties.secondaryColor || "#FFFFFF";

    const theme = React.useMemo(
        () =>
            createTheme({
                palette: {
                    primary: {
                        main: primaryColor
                    },
                    secondary: {
                        main: secondaryColor
                    },
                    background: {
                        default: backgroundColor
                    }
                },
                typography: {
                    fontFamily: "Roboto, Arial, sans-serif"
                },
                components: {
                    MuiIconButton: {
                        styleOverrides: {
                            root: {
                                "&:focus": {
                                    outline: "none"
                                }
                            }
                        }
                    },
                    MuiButton: {
                        styleOverrides: {
                            root: {
                                "&:focus": {
                                    outline: "none"
                                }
                            }
                        }
                    },
                    MuiInputBase: {
                        styleOverrides: {
                            root: {
                                "&:focus": {
                                    outline: "none"
                                }
                            }
                        }
                    },
                    MuiOutlinedInput: {
                        styleOverrides: {
                            root: {
                                "&:focus": {
                                    outline: "none"
                                }
                            }
                        }
                    },
                    MuiTextField: {
                        styleOverrides: {
                            root: {
                                "&:focus": {
                                    outline: "none"
                                }
                            }
                        }
                    },
                    MuiTab: {
                        styleOverrides: {
                            root: {
                                "&:focus": {
                                    outline: "none"
                                }
                            }
                        }
                    }
                }
            }),
        [primaryColor]
    );

    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default MuiThemeProviderDynamic;
